import React, {useEffect, useRef, useState} from 'react'
import {getPurchaseDetail} from "../../../services/servicePurchase";
import {Button, Card} from "antd";
import {useParams} from "@reach/router";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import PurchaseDetailItems from "./PurchaseDetailItems";
import {useReactToPrint} from "react-to-print";


const PurchaseDetail = () => {
    const {purchaseId} = useParams()
    const [detailData, setDetailData] = useState([])
    const [subTotal, setSubTotal] = useState(0)
    const [abstractInfo, setAbstractInfo] = useState({})

    useEffect(() => {
        getPurchaseDetail(purchaseId)
            .then(({data}) => handleData(data))
    }, [])

    const handleData = (data) => {
        let purchaseContent = data.purchase
        let subs = 0;
        const itemList = purchaseContent.contentOfPurchaseList.map((item, index) => {
            subs += item.lineTotal;
            return {
                key: index,
                stockName: item.stock ? `${item.stock.code} - ${item.stock.name}` : '',
                quantity: item.quantity,
                supplier: item.supplier ? `${item.supplier.name}` : '',
                currency: item.selectedCurrency,
                unitPrice: item.linePrice,
                lineTotal: item.lineTotal,
                unit: item.unit,
                shippingDate: item.shippingDate,
                discount: item.discount
            }
        })

        const infos = {
            whom: purchaseContent.whom || '-',
            currencyInfo: purchaseContent.exchangeRate || '-',
            payment: purchaseContent.payment || '-',
            status: purchaseContent.purchaseStatus || '-',
            purchaseNumber: purchaseContent.purchaseNumber || '-',
            recipe: purchaseContent.recipe ? purchaseContent.recipe.name : '-'
        }

        setSubTotal(subs)
        setDetailData(itemList)
        setAbstractInfo(infos)
    }
    const columns = [
        {
            title: 'Tedarikçi',
            dataIndex: 'supplier',
            key: 'supplier',
        },
        {
            title: 'Stok Adı',
            dataIndex: 'stockName',
            key: 'stockName',
        },
        {
            title: 'Birim',
            dataIndex: 'unit',
            key: 'unit',
        },
        {
            title: 'Miktar',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Birim Fiyat',
            dataIndex: 'unitPrice',
            key: 'unitPrice',
        },
        {
            title: 'Para Birimi',
            dataIndex: 'currency',
            key: 'currency',
        },
        {
            title: 'Iskonto %',
            dataIndex: 'discount',
            key: 'discount',
        },
        {
            title: 'Sevk Tarihi',
            dataIndex: 'shippingDate',
            key: 'shippingDate',
            render: (t) => userDateFormatter(t)
        },
        {
            title: 'Toplam',
            dataIndex: 'lineTotal',
            key: 'lineTotal',
        },
    ]
    const handleHistoryBack = () => window.location.href = `${window.location.origin}/landing/purchase`;
    const componentPrint = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentPrint.current,
    });

    return (
        <React.Fragment>
            <Card title={'Satın Alma Detay'}
                  extra={[
                      <Button key={'backBtn'} type={'primary'} onClick={handleHistoryBack}>Geri</Button>,
                      <Button key={'printBtn'} style={{marginLeft: '16px'}} onClick={handlePrint}> Yazdır </Button>
                  ]}
            >
                <PurchaseDetailItems ref={componentPrint}
                                     tableColumns={columns}
                                     tableData={detailData}
                                     abstractInfo={abstractInfo}
                                     subTotal={subTotal}
                />
            </Card>
        </React.Fragment>
    )
}
export default PurchaseDetail